import { Button } from '@ui/components';
import { Link, useRouteError } from 'react-router-dom';

const ErrorPage: React.FC = () => {
  const error = useRouteError() as { statusText: string; message: string };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="mb-4 text-4xl font-bold text-red-600">
          Oops! Something went wrong
        </h1>
        <p className="mb-8 text-xl text-gray-700">
          {error.message || error.statusText || 'An unexpected error occurred'}
        </p>
        <div className="space-x-4">
          <Link to="/">
            <Button variant="outline">Back Home</Button>
          </Link>
          <Link to="/">
            <Button onClick={() => window.location.reload()}>
              Refresh Page
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ErrorPage;
